

function Mission() {
    return (
        <div className="mission-div">
            <h2 className="mission-h2">Our Mission:</h2>
            <p className="mission-p">Our mission is simple:<br/> to transform homes into spaces that reflect the unique style and needs of their owners. Whether it's breathing new life into an old property or updating a modern home, we deliver high-quality craftsmanship and attention to detail in every project.</p>
        </div>
    )
}

export default Mission;